/**
 * Natural ("Finder-like") string comparison: "2" < "10", "P3" < "P12".
 * Swedish locale so å/ä/ö sort as users expect.
 */
export const naturalCompare = (a: string, b: string): number => {
    return a.localeCompare(b, 'sv', { numeric: true, sensitivity: 'base' });
};
